module.exports = __webpack_public_path__ + "img/part2.967c8c82.png";